import {
  Cell,
  Label,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

type Props = {
  innerRadius?: number;
  outerRadius?: number;
  pieChartDatas: object[];
  dataKey: string;
  pieChartColors?: string[];
  pieChartLabel?: string;
};

const CustomPieChart: React.FC<Props> = ({
  innerRadius,
  outerRadius,
  pieChartDatas,
  dataKey,
  pieChartColors,
  pieChartLabel,
}) => {
  return (
    <ResponsiveContainer width={"100%"} height={400}>
      <PieChart>
        <Pie
          dataKey={dataKey}
          data={pieChartDatas}
          cx='50%'
          cy='50%'
          innerRadius={innerRadius && innerRadius}
          outerRadius={outerRadius && outerRadius}
        >
          {pieChartDatas?.map((_, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                pieChartColors && pieChartColors[index % pieChartColors?.length]
              }
            />
          ))}
          <Label
            value={pieChartLabel}
            className='text-xl font-medium'
            position={"center"}
          />
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CustomPieChart;
